import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'savorias_selected_location_id'

/**
 * Hook to persist the selected location ID in localStorage.
 * Validates stored ID against available locations and falls back to first if invalid.
 */
export function useLocationPersistence(availableLocationIds: number[]) {
  const [selectedLocationId, setSelectedLocationIdState] = useState<number | null>(() => {
    if (typeof window === 'undefined') return null
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? parseInt(stored, 10) : null
  })

  // Validate stored ID against available locations
  useEffect(() => {
    if (availableLocationIds.length === 0) return

    if (selectedLocationId === null || !availableLocationIds.includes(selectedLocationId)) {
      // Default to first available location
      const defaultId = availableLocationIds[0]
      setSelectedLocationIdState(defaultId)
      localStorage.setItem(STORAGE_KEY, defaultId.toString())
    }
  }, [availableLocationIds, selectedLocationId])

  const setSelectedLocationId = useCallback((id: number | null) => {
    if (id !== null) {
      localStorage.setItem(STORAGE_KEY, id.toString())
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
    setSelectedLocationIdState(id)
  }, [])

  return { selectedLocationId, setSelectedLocationId }
}
